var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mode === "DESIGN"
        ? _c(
            "div",
            { staticClass: "input-con max-width" },
            [
              _c("el-input", {
                staticClass: "disabled-box",
                attrs: { size: "small", placeholder: _vm.placeholder },
              }),
              _vm.unit
                ? _c("span", { staticClass: "unit" }, [
                    _vm._v(_vm._s(_vm.unit)),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showChinese,
                      expression: "showChinese",
                    },
                  ],
                  staticClass: "chinese-con",
                },
                [
                  _c("span", { staticClass: "text" }, [_vm._v("大写：")]),
                  _c("span", { staticClass: "chinese" }, [
                    _vm._v(_vm._s(_vm.chinese)),
                  ]),
                ]
              ),
            ],
            1
          )
        : [
            !_vm.readerMode || _vm.perm === "E"
              ? _c(
                  "div",
                  { staticClass: "input-con input-con-number w-220" },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        min: 0,
                        "controls-position": "right",
                        precision: _vm.precision,
                        size: "small",
                        clearable: "",
                        disabled: _vm.perm === "R",
                        placeholder: _vm.placeholder,
                      },
                      model: {
                        value: _vm._value,
                        callback: function ($$v) {
                          _vm._value = $$v
                        },
                        expression: "_value",
                      },
                    }),
                    _vm.unit
                      ? _c("span", { staticClass: "unit" }, [
                          _vm._v(_vm._s(_vm.unit)),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showChinese,
                            expression: "showChinese",
                          },
                        ],
                        staticClass: "chinese-con",
                      },
                      [
                        _c("span", { staticClass: "text" }, [_vm._v("大写：")]),
                        _c("span", { staticClass: "chinese" }, [
                          _vm._v(_vm._s(_vm.chinese)),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "form-item-text" },
                  [
                    _vm._v(" " + _vm._s(_vm._value)),
                    _vm.unit ? [_vm._v(_vm._s(_vm.unit))] : _vm._e(),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showChinese,
                            expression: "showChinese",
                          },
                        ],
                        staticClass: "chinese-con",
                      },
                      [
                        _c("span", { staticClass: "chinese" }, [
                          _vm._v("（" + _vm._s(_vm.chinese) + "）"),
                        ]),
                      ]
                    ),
                  ],
                  2
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }